module.exports = __webpack_public_path__ + "static/img/s12.a0f369e4.png";